<mat-form-field id="inputCOMP-form" [formGroup]="group" class="custom-form-field">
  <mat-label>{{ field.displayName }}</mat-label>
  <input
    *ngIf="field.inputType !== 'number'"
    matInput
    [formControlName]="field.name"
    [name]="field.name"
    [type]="field.inputType"
    autocomplete="off"
  />
  <input
    *ngIf="field.inputType === 'number'"
    matInput
    [formControlName]="field.name"
    [name]="field.name"
    onkeydown="
      javascript: return event.keyCode === 190 || event.keyCode === 8 || event.keyCode === 46
        ? true
        : !isNaN(Number(event.key));
    "
    [type]="field.inputType"
    autocomplete="off"
  />
  <ng-container id="inputCOMP-form-ng-container" *ngFor="let validation of field.validations" ngProjectAs="mat-error">
    <mat-error id="inputCOMP-form-error{{ field.name }}" *ngIf="group.get(field.name).hasError(validation.name)">{{
      validation.message
    }}</mat-error>
  </ng-container>
</mat-form-field>
